import { FormatMoney } from '../../../../hooks/useMoney';

const PART_SEPARATOR = ' · ';

interface FormatCityStateParams {
  city?: string;
  state?: string;
}

export const joinResultParts = (parts: Array<string | undefined | null>): string =>
  parts.filter((part): part is string => Boolean(part && part.trim())).join(PART_SEPARATOR);

export const formatCityState = ({ city, state }: FormatCityStateParams): string => {
  if (city && state) {
    return `${city} - ${state}`;
  }

  return city ?? state ?? '';
};

export const formatOptionalMoney = (
  value: number | undefined,
  formatMoney: FormatMoney,
): string | undefined => (value !== undefined ? formatMoney(value) : undefined);
